import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsPersonFill } from "react-icons/bs";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import img from "../../assets/seller/loading.png";

function SellerView() {
  const [sellerData, setSellerData] = useState({});
  const [bannerData, setBannerData] = useState({});
  const [sponsoredData, setSponsoredData] = useState({});
  const [offerData, setOfferData] = useState({});
  const [sellerProducts, setSellerProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const { companyId } = useParams();
  const navigate = useNavigate();

  // Fetch Seller Data
  useEffect(() => {
    if (!companyId) {
      navigate("/admin/seller");
      return;
    }

    const fetchSellerData = async () => {
      try {
        const response = await USER_URL.get(
          `/accounts/admin/companies/${companyId}/`,
          {},
        );
        console.log("seller", response.data.data);
        if (response.data?.data) {
          setSellerData(response.data.data.company_details);
          setSellerProducts(response.data.data.products);
          setBannerData(response.data.data.banner);
          setSponsoredData(response.data.data.sponsored);
          setOfferData(response.data.data.special_offer);
        }
      } catch (error) {
        console.error("Error fetching seller data:", error.message || error);
      } finally {
        setLoading(false);
      }
    };

    // const fetchSellerProducts = async () => {
    //   try {
    //     const response = await USER_URL.get(`/accounts/admin/companies/${companyId}/products/`, {
    //       // headers: { Authorization: `Token ${token}` },
    //     });
    //     if (response.data?.Data) {
    //       setSellerProducts(response.data.Data); // Assuming this returns an array of products
    //     }
    //   } catch (error) {
    //     console.error("Error fetching seller products:", error.message || error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // fetchSellerProducts();
    fetchSellerData();
  }, [companyId, navigate, token]);

  console.log(sellerProducts);

  if (loading) {
    return (
      <div className="mt-10 text-center text-green-500">
        Loading seller data...
      </div>
    );
  }

  if (!sellerData) {
    return (
      <div className="mt-10 text-center text-red-500">No data available.</div>
    );
  }

  // Helper function to display data or "No [field]" text
  const displayData = (data, fieldName) => {
    return data ? data : `No ${fieldName}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <h1 className="mb-5 text-end font-semibold text-green-500">
        {sellerData.name
          ? `Allocated Sub Admin: ${sellerData.name}`
          : "No allocated sub admin"}
      </h1>
      <div className="mb-8 flex items-center space-x-6">
        <div className="flex h-24 w-24 cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-yellow-300">
          <BsPersonFill className="size-20 text-gray-500" />
        </div>
        {/* Logo */}
        <div className="flex h-24 w-24 items-center justify-center rounded-lg border-2 border-gray-300 shadow-md">
          {sellerData.logo ? (
            <img
              src={
                sellerData.logo instanceof File
                  ? URL.createObjectURL(sellerData.logo)
                  : `${BASE_URL}${sellerData.logo}`
              }
              alt={displayData(sellerData.name, "name")}
              className="h-full w-full rounded-lg object-contain"
            />
          ) : (
            <span className="text-gray-500">No logo</span>
          )}
        </div>
      </div>

      {/* Personal Info Section */}
      <div className="mb-10 grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <h2 className="mb-4 text-2xl font-bold">Personal Info</h2>
          <div className="space-y-4">
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Name
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.full_name, "name")}
              </p>
            </div>
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Email
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.email, "email")}
              </p>
            </div>
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Phone Number
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.mobile_number, "phone number")}
              </p>
            </div>
          </div>
        </div>

        {/* Company Info Section */}
        <div>
          <h2 className="mb-4 text-2xl font-bold">Company Info</h2>
          <div className="space-y-4">
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Company Name
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.company_name, "company name")}
              </p>
            </div>
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Company Location
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.location, "location")}
              </p>
            </div>
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <span className="mb-1 block text-sm font-medium text-gray-600">
                Company Email
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {displayData(sellerData.company_mail, "company email")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Active Services Section */}
      <div className="mb-10">
        <h2 className="mb-4 text-2xl font-bold">Active Services</h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {[
            {
              title: "Banner",
              data: bannerData?.banner_image,
              id: bannerData?.id,
              path: `/admin/approval/banner/view/${bannerData?.id}`,
            },
            {
              title: "Sponsored Products",
              data: sponsoredData?.sponsored_banner,
              id: sponsoredData?.id,
              path: `/admin/approval/sponsor/view/${sponsoredData?.id}`,
            },
            {
              title: "Offer Products",
              data: offerData?.special_offer_banner,
              id: offerData?.id,
              path: `/admin/approval/offer/view/${offerData?.id}`,
            },
          ].map(({ title, data, id, path }) => (
            <div key={title} className="rounded-lg bg-white p-4 shadow-md">
              <h3 className="mb-4 text-center text-lg font-bold text-gray-800">
                {title}
              </h3>
              <div className="mb-4 flex h-24 items-center justify-center overflow-hidden rounded-md bg-gray-100">
                {data ? (
                  <img
                    src={`${BASE_URL}${data}`}
                    alt={title}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <span className="text-gray-500">No image</span>
                )}
              </div>

              {id ? (
                <Link
                  to={path}
                  className="mb-2 block w-full rounded-lg bg-blue-500 py-2 text-center text-white hover:bg-blue-600"
                >
                  View
                </Link>
              ) : (
                <div className="rounded-lg border py-2 text-center text-gray-400">
                  No view available
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Seller Products Section */}
      <div className="mb-8">
        <h2 className="mb-4 text-2xl font-bold">Seller Products</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse rounded-lg bg-white shadow-sm">
            <thead>
              <tr>
                {sellerProducts?.length === 0 ? (
                  <th colSpan="8" className="text-center">
                    <div className="mt-7 flex flex-col items-center justify-center space-y-4">
                      <img
                        src={img}
                        alt="Cart is empty"
                        className="w-52 object-cover"
                      />
                      <h2 className="text-2xl font-medium text-gray-700">
                        No Products Found!
                      </h2>
                    </div>
                  </th>
                ) : (
                  ["Item No", "Product Code", "Name", "Stock", "Price", ""].map(
                    (header, index) => (
                      <th
                        key={index}
                        className="p-2 text-left text-sm font-bold text-green-500"
                      >
                        {header}
                      </th>
                    ),
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {sellerProducts?.map((product, index) => (
                <tr key={product.id || index} className="">
                  <td>
                    <div className="flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {index + 1}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {displayData(product.product_code, "product code")}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {displayData(product.name, "name")}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {displayData(product.stock, "stock")}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                      {displayData(product.price, "price")}
                    </div>
                  </td>
                  {/* <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {displayData(product.status, "status")}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {displayData(product.adminStatus, "admin status")}
                    </div>
                  </td> */}
                  <td className="p-2">
                    <Link
                      to={`/admin/product-details/${product.id}`}
                      className="rounded-lg border border-green-600 px-4 py-2 text-sm font-medium text-green-600 hover:bg-green-100"
                    >
                      VIEW
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SellerView;
